<template>
  <div>
    <CDropdown inNav
                class="c-header-nav-items"
                placement="bottom-end"
                add-menu-classes="pt-0">
      <template #toggler>
        <CHeaderNavLink>
          <div class="c-avatar">
            <img :src="require('@shared/assets/img/user.jpeg')"
                  class="c-avatar-img " />
          </div>
        </CHeaderNavLink>
      </template>
      <div v-if="displayName" class="px-3 py-2 small text-muted">
        <strong>{{ displayName }}</strong>
        <div v-if="lastActivityFormatted">Last Activity: {{ lastActivityFormatted }}</div>
      </div>
      <CDropdownDivider v-if="displayName" />
      <CDropdownItem href="/support">
        <i class="fa fa-ticket fa-2xl mr-2"></i> Support
      </CDropdownItem>
      <CDropdownItem href="/change-password">
        <i class="fa fa-pencil fa-2xl mr-2"></i> Change Password
      </CDropdownItem>
      <CDropdownItem @click="$bvModal.show('display-settings-modal')">
        <i class="fa fa-cog fa-2xl mr-2"></i> Display Settings
      </CDropdownItem>
      <CDropdownDivider />
      <CDropdownItem @click="logout">
        <CIcon name="cil-lock-locked" /> Logout
      </CDropdownItem>
    </CDropdown>

    <b-modal id="display-settings-modal" title="Display Settings" hide-footer>
      <b-row>
        <b-col>
          <b-form-group label="Datagrid Text Size">
            <b-form-select v-model="dxDatagridTextSize"
              :options="edenDatagridTextSizeOptions" />
          </b-form-group>

          <b-form-group label="Lock datagrid header/footer">
            <b-form-radio-group
              v-model="dxDatagridHeight"
              :options="edenDatagridHeightOptions"
              name="dxDatagridHeight"
              stacked
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
  import dayjs from 'dayjs'
  import DxDatagridConfigMixin from '@shared/mixins/DxDatagridConfig'

  export default {
    name: 'TheHeaderDropdownAccnt',
    mixins: [DxDatagridConfigMixin],
    data () {
      return {

      }
    },

    computed: {
      displayName() {
        const profile = this.$store.getters.userProfile
        return profile?.displayName || profile?.username || this.$store.getters.username
      },
      lastActivityFormatted() {
        const raw = this.$store.getters.userProfile?.lastActivityAt
        if (!raw) return null
        const d = dayjs(raw)
        if (!d.isValid()) return null
        return d.format('MM/DD/YY h:mm A')
      },
    },

    methods: {
      async logout() {
        try {
          this.$store.commit('reset')
          await this.$router.replace('/login')
        } catch (e) {
          this.$log.error('Error logging out', e)
        }

        window.location.href = window.location.href
      }
    },
  }
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>